module.exports = __webpack_public_path__ + "img/stylist-freestyler-desktop.webp";